class KrealabAjaxForm{

    constructor(){
        jQuery('[data-kreenoot-ajax-form="1"]').on('submit', this.send_ajax_form);
    }

    send_ajax_form(e) {
        e.preventDefault();

        var form = jQuery(this)[0],
            data = new FormData(form);

        jQuery.ajax({
            method: form.getAttribute('method'),
            url: kreenoot_child.ajax_url,
            data: data,
            contentType: false,
            processData: false,
            beforeSend: function () {
                form.querySelector('button').setAttribute('disabled', 'disabled');
                form.querySelectorAll('.alert-kreenoot-ajax-form').forEach(e => {
                   e.parentNode.removeChild(e);
                });
            },
            success: function (response) {
                KrealabAjaxForm.notifycation_form(form, response);
                form.querySelector('button').removeAttribute('disabled');
            },
            error: function (data) {
                let errors = data.responseJSON.errors;
                console.log(errors);

                jQuery.each(errors, function (key, v) {
                    let element = KrealabAjaxForm.add_element('p', v.message + ' in ' + v.file + ' on line ' + v.line, false);
                    form.prepend(element);
                });

                form.querySelector('button').removeAttribute('disabled');
            }
        });
    }

    static notifycation_form(formElement, response){
        if ( !response.success) {
            let errors = response.data;

            jQuery.each(errors, function (key, v) {
                if(jQuery.isArray(v)){
                    let global_element = document.createElement('div');
                        global_element.className = 'alert-kreenoot-ajax-form alert-kreenoot-ajax-form-danger';

                    jQuery.each(v, function (v_key, v_v) {
                        let error = KrealabAjaxForm.add_element('div', v_v);
                        global_element.append(error);
                    });

                    if ('global' === key) {
                        formElement.prepend(global_element);
                    }else{
                        if(jQuery('[name="' + key + '"]').is(':checkbox') || jQuery('[name="' + key + '"]').is(':radio')){
                            jQuery(global_element).insertAfter('[for="' + key + '"]');
                        }else{
                            jQuery(global_element).insertAfter('[name="' + key + '"]');
                        }
                    }

                }else if ('global' === key) {
                    let element = KrealabAjaxForm.add_element('p', v, false);
                    formElement.prepend(element);
                } else {
                    let element = KrealabAjaxForm.add_element('p', v, false);
                    if(jQuery('[name="' + key + '"]').is(':checkbox') || jQuery('[name="' + key + '"]').is(':radio')){
                        jQuery(element).insertAfter('[for="' + key + '"]');
                    }else{
                        jQuery(element).insertAfter('[name="' + key + '"]');
                    }
                }
            });
        }

        // Reset form
        if (response.success) {

            if(response.data.message){
                let element = KrealabAjaxForm.add_element('p', response.data.message, true);
                formElement.prepend(element);
            }

            // Reset the form
            formElement.reset();

            if (response.data.message) {
                setTimeout(function () {
                    if (response.data.redirect) {
                        window.location.href = response.data.redirect;
                    }
                }, 1000);
            }else{
                if (response.data.redirect) {
                    window.location.href = response.data.redirect;
                }
            }
        }
    }

    static add_element(element_tag, content, success = null){
        let element = document.createElement(element_tag);
        if(null !== success){
            element.className = 'alert-kreenoot-ajax-form alert-kreenoot-ajax-form-' + ((success) ? 'success' : 'danger');
        }
        let message = document.createTextNode(content);
        element.appendChild(message);

        return element;
    }
}

export default KrealabAjaxForm;
